<template>
	<b-container id="generate-picture-file" v-if="$can('view-generate-picture-file') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <h3>Generate Picture File</h3>
                <hr>
            </b-container>
        </b-row>

        <b-row class="button-row">
            <b-col cols="4">
                <b-button size="sm" variant="outline-dark" @click="exportExcel"><i class="fas fa-file-excel fa-2x"></i> Excel</b-button>
                <b-button size="sm" variant="outline-dark" @click="exportPDF"><i class="fas fa-file-pdf fa-2x"></i> PDF</b-button>
                <b-button size="sm" variant="outline-dark" @click="openModal('excel-paste')"><i class="fas fa-paste fa-2x"></i> PASTE CSV</b-button>
            </b-col>
            <b-col>
                <b-form-input v-model="headerText" size="sm" placeholder="Header Text"></b-form-input>
            </b-col>
            <b-col cols="4">
                <div class="import-file-wrap d-flex align-items-center">
                    <b-form-file
                        v-model="importFile"
                        size="sm"
                        accept=".csv,.xls,.xlsx"
                        placeholder="Drag CSV/XLSX here or click to select"
                        drop-placeholder="Drop CSV/XLSX file here..."
                        @input="onImportFileSelected"
                        class="flex-grow-1"
                    ></b-form-file>
                    <b-button size="sm" variant="link" class="sample-link p-0 ml-2 text-nowrap" @click="downloadImportSample">Sample</b-button>
                </div>
            </b-col>
            <b-col class="text-right">
                <b-button size="sm" variant="outline-danger" @click="resetView"><i class="fas fa-redo fa-2x"></i> Reset View</b-button>
            </b-col>
        </b-row>

        <b-table-simple hover small responsive bordered sticky-header="550px">
            <b-thead>
                <b-tr>
                    <b-th class="text-center"></b-th>
                    <b-th class="text-center">Photo</b-th>
                    <b-th>SKU</b-th>
                    <b-th class="qty text-center">QTY</b-th>
                    <b-th class="qty text-center">
                        <b-container fluid>
                            <b-row>
                                <b-col>INSTOCK</b-col>
                                <b-col class="text-right">
                                    <b-form-checkbox
                                        id="checkbox-instock"
                                        v-model="show.instock"
                                        name="checkbox-instock"
                                        :value="true"
                                        :unchecked-value="false"
                                    ></b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-th>
                    <b-th colspan="3" class="qty text-center">Status</b-th>
                    <b-th>
                        <b-container fluid>
                            <b-row>
                                <b-col>Title</b-col>
                                <b-col class="text-right">
                                    <b-form-checkbox
                                        id="checkbox-title"
                                        v-model="show.title"
                                        name="checkbox-title"
                                        :value="true"
                                        :unchecked-value="false"
                                        >
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-th>
                    <b-th class="price text-center">
                        <b-container fluid>
                            <b-row>
                                <b-col >Price</b-col>
                                <b-col class="text-right">
                                    <b-form-checkbox
                                        id="checkbox-price"
                                        v-model="show.price"
                                        name="checkbox-price"
                                        :value="true"
                                        :unchecked-value="false"
                                        >
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-th>
                    <b-th class="price text-center">Discount Price</b-th>
                    <b-th class="price text-center">% Discount</b-th>
                    <b-th class="price text-center">Total</b-th>
                    <b-th v-if="canViewWac" class="price text-center">
                        <b-container fluid>
                            <b-row>
                                <b-col>WAC</b-col>
                                <b-col class="text-right">
                                    <b-form-checkbox
                                        id="checkbox-wac"
                                        v-model="show.wac"
                                        name="checkbox-wac"
                                        :value="true"
                                        :unchecked-value="false"
                                    ></b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-th>
                    <b-th class="qty text-center">
                        <b-container fluid>
                            <b-row>
                                <b-col>QOO</b-col>
                                <b-col class="text-right">
                                    <b-form-checkbox
                                        id="checkbox-qoo"
                                        v-model="show.qoo"
                                        name="checkbox-qoo"
                                        :value="true"
                                        :unchecked-value="false"
                                    ></b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-th>
                    <b-th class="qty text-center">
                        <b-container fluid>
                            <b-row>
                                <b-col>QOP</b-col>
                                <b-col class="text-right">
                                    <b-form-checkbox
                                        id="checkbox-qop"
                                        v-model="show.qop"
                                        name="checkbox-qop"
                                        :value="true"
                                        :unchecked-value="false"
                                    ></b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-th>
                    <b-th>
                        <b-container fluid>
                            <b-row>
                                <b-col>Category</b-col>
                                <b-col class="text-right">
                                    <b-form-checkbox
                                        id="checkbox-category"
                                        v-model="show.category"
                                        name="checkbox-category"
                                        :value="true"
                                        :unchecked-value="false"
                                    ></b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-th>
                    <b-th>Notes</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, index) in row.items" :key="index" :class="`index-${index}`">
                    <td class="text-center"><b-button size="sm" variant="danger" @click="deleteRow(index)"><i class="far fa-trash-alt fa-sm"></i></b-button></td>
                    <td class="text-center">
                        <b-img-lazy v-if="row.items[index].url" class="products-thumbs" :src="item.url"></b-img-lazy>
                    </td>
                    <td>
                        <div class="options-assign">
                            <div class="autosuggest-container">
                                <vue-autosuggest
                                    v-model="row.items[index].sku"
                                    :suggestions="autosuggest.suggestions"
                                    @focus.once="focusMe(index)"
                                    @click="clickHandler"
                                    @input="fetchResults"
                                    @selected="onSelected"
                                    @keydown.tab="onKeyTab"
                                    :get-suggestion-value="getSuggestionValue"
                                    :input-props="{id:'autosuggest__input_' + index, placeholder:''}"
                                    @keyup.enter="suggestFirst(index, $event.target.value)"
                                    :ref="'input' + index"
                                >

                                <b-container slot-scope="{suggestion}" fluid>
                                    <b-row>
                                        <b-col cols="2">
                                            <b-img-lazy class="products-thumbs" :src="suggestion.item.url"></b-img-lazy>
                                        </b-col>
                                        <b-col class="text-right">
                                            {{ suggestion.item.name }}
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </vue-autosuggest>
                            </div>
                        </div>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].qty" size="sm" class="text-center" @input="calculateRow(index)"></b-form-input>
                    </td>
                    <td>
                        <b-form-input :value="row.items[index].instock" size="sm" class="text-center" readonly></b-form-input>
                    </td>
                    <td colspan="3" class="text-center">
                        <b-form-radio-group v-model="row.items[index].status">
                            <b-form-radio v-for="status in statusOptions" :key="status.id" :value="status.value">{{ status.label }}</b-form-radio>
                        </b-form-radio-group>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].title" size="sm" v-bind:class="{ 'hide-data': show.title == false }" readonly></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].price" size="sm" v-bind:class="{ 'hide-data': show.price == false }" class="text-center" readonly @change="calculateRow(index)" @input="calculateRow(index)"></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].discountPrice" size="sm" class="text-center" @input="calculateRow(index)" :readonly="row.items[index].percentDiscount.length ? true : false"></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].percentDiscount" size="sm" class="text-center" @input="calculateRow(index)":readonly="row.items[index].discountPrice.length ? true : false"></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].total" size="sm" class="text-center" readonly></b-form-input>
                    </td>
                    <td v-if="canViewWac">
                        <b-form-input :value="formatWac(row.items[index].wac)" size="sm" class="text-center" readonly></b-form-input>
                    </td>
                    <td>
                        <b-form-input :value="row.items[index].qoo" size="sm" class="text-center" readonly></b-form-input>
                    </td>
                    <td>
                        <b-form-input :value="row.items[index].qop" size="sm" class="text-center" readonly></b-form-input>
                    </td>
                    <td>
                        <b-form-input :value="row.items[index].category" size="sm" readonly></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].notes" size="sm"></b-form-input>
                    </td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-row>
            <b-col cols="1">
                <b-button size="sm" @click="addTenRows"><i class="fas fa-plus"></i> 10</b-button>
            </b-col>
        </b-row>

        <modal-excel-paste
            v-if="modals['modal-inventory-generatepicturefile-excel-paste'].active"
            ref="excelPasteModal"
            @pasteContents="onPasteContents"
        />
    </b-container>
</template>

<script>
    import { VueAutosuggest } from "vue-autosuggest"
    import * as XLSX from 'xlsx/xlsx.mjs'
    import ModalExcelPaste from './modals/ExcelPaste'
	export default {
        name: 'GeneratePictureFile',

        metaInfo() {
            return {
                title: 'Generate Picture File',
            }
        },

        components: {
            VueAutosuggest,
            'modal-excel-paste': ModalExcelPaste,
        },

		data() {
            return {
                statusOptions: [
                    { id: 1, label: 'New', value: 'new' },
                    { id: 2, label: 'OOS', value: 'oos' },
                    { id: 3, label: 'BIS', value: 'bis' },
                ],
                modals: {
                    'modal-inventory-generatepicturefile-excel-paste': {
                        active: 0
                    },
                },
                show: {
                    title: true,
                    price: true,
                    instock: false,
                    wac: false,
                    qoo: false,
                    qop: false,
                    category: false
                },

                autosuggest: {
                    suggestions: [],
                    debounceMilliseconds: 500,
                    timeout: null
                },

                cacheKey: 1,

                row: {
                    items: []
                },
                locations: ['A', 'B'],
                headerText: '',
                products: [
                    {
                        data: []
                    }
                ],
                currentIndex: '',
                importFile: null,
                isImportingFile: false,
                importColumnAliases: {
                    sku: ['sku'],
                    qty: ['qty', 'quantity'],
                    price: ['price'],
                    'discount price': ['discount price', 'discountprice'],
                    'percent discount': ['% discount', 'percent discount', '%discount'],
                    total: ['total'],
                    notes: ['notes', 'note']
                }
			}
		},

		methods: {
            createEmptyRow() {
                return {
                    sku: '',
                    qty: '',
                    instock: '',
                    status: '',
                    price: '',
                    title: '',
                    discountPrice: '',
                    total: '',
                    percentDiscount: '',
                    wac: '',
                    qoo: '',
                    qop: '',
                    category: '',
                    notes: '',
                    url: ''
                }
            },

            formatWac(value) {
                if (value === '' || value === null || value === undefined) {
                    return ''
                }

                return Number(value).toFixed(2)
            },

            applyProductToRow(index, product) {
                if (!product) {
                    return
                }

                this.row.items[index].sku = product.name || product.sku || ''
                this.row.items[index].title = product.title || ''
                this.row.items[index].price = product.price || ''
                this.row.items[index].url = product.url || ''
                this.row.items[index].instock = product.instock ?? product.available ?? ''
                this.row.items[index].wac = this.canViewWac ? (product.wac ?? '') : ''
                this.row.items[index].qoo = product.qoo ?? ''
                this.row.items[index].qop = product.qop ?? ''
                this.row.items[index].category = product.category || ''
            },

            clearProductFields(index) {
                this.row.items[index].title = ''
                this.row.items[index].price = ''
                this.row.items[index].url = ''
                this.row.items[index].instock = ''
                this.row.items[index].wac = ''
                this.row.items[index].qoo = ''
                this.row.items[index].qop = ''
                this.row.items[index].category = ''
            },

            openModal(modalName) {
                let prefix = 'modal-inventory-generatepicturefile-'
                switch (modalName) {
                    case 'excel-paste':
                        this.modals[prefix + modalName].active = 1
                        break
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            updateRowItems(rows) {
                this.row.items = rows
            },

            async onPasteContents(pasteContents) {
                try {
                    const importRows = this.parsePastedContents(pasteContents)
                    const imported = await this.processImportRows(importRows)
                    if (imported && this.$refs.excelPasteModal) {
                        this.$refs.excelPasteModal.closeAfterSuccess()
                    } else if (this.$refs.excelPasteModal) {
                        this.$refs.excelPasteModal.resetSubmitting()
                    }
                } catch (err) {
                    const message = err.response?.data?.message || err.message || 'Unable to parse/import the pasted content. Please verify format.'
                    this.showAlertBox('error', 'Paste Failed', message)
                    if (this.$refs.excelPasteModal) {
                        this.$refs.excelPasteModal.resetSubmitting()
                    }
                }
            },

            async onImportFileSelected(file) {
                if (!file || this.isImportingFile) {
                    return
                }

                const fileName = (file.name || '').toLowerCase()
                const validExtensions = ['.csv', '.xls', '.xlsx']
                const hasValidExtension = validExtensions.some((ext) => fileName.endsWith(ext))

                if (!hasValidExtension) {
                    this.showAlertBox('error', 'Invalid File Type', 'Only CSV, XLS, and XLSX files are supported.')
                    this.importFile = null
                    return
                }

                this.isImportingFile = true
                try {
                    const importRows = await this.parseImportFile(file)
                    await this.processImportRows(importRows)
                } catch (err) {
                    const message = err.response?.data?.message || err.message || 'Unable to parse/import the selected file. Please verify file format.'
                    this.showAlertBox('error', 'Import Failed', message)
                } finally {
                    this.isImportingFile = false
                    this.importFile = null
                }
            },

            async processImportRows(importRows) {
                if (!importRows.length) {
                    throw new Error('No valid rows found. Include at least the SKU column, or paste one SKU per line.')
                }

                const discountConflict = this.findDiscountConflict(importRows)
                if (discountConflict) {
                    throw new Error(discountConflict)
                }

                const validationError = this.validateImportRows(importRows)
                if (validationError) {
                    throw new Error(validationError)
                }

                const rowsForImport = await this.resolvePriceOverridePreference(importRows)
                if (!rowsForImport) {
                    return false
                }

                const res = await axios.post('api/inventory/generatepicturefile/processimport', {
                    rows: rowsForImport
                })

                if (res.data.status === 'error') {
                    throw new Error(res.data.message || 'Import validation failed.')
                }

                const importedRows = res.data.rows || []
                if (!importedRows.length) {
                    throw new Error('No import rows matched existing SKU records.')
                }

                const targetRows = await this.resolveImportConflict(importedRows)
                if (!targetRows) {
                    return false
                }

                this.row.items = targetRows
                this.recalculateAllRows()
                this.showAlertBox(
                    'success',
                    'Import Complete',
                    `Processed: ${res.data.processed || importedRows.length}, Skipped: ${res.data.skipped || 0}`
                )

                return true
            },

            parsePastedContents(pasteContents) {
                const lines = String(pasteContents || '')
                    .split(/\r\n|\r|\n/)
                    .map((line) => line.trim())
                    .filter((line) => line !== '')

                if (!lines.length) {
                    return []
                }

                const firstLineCells = this.splitPasteLine(lines[0])
                const headerRow = firstLineCells.map((header) => this.normalizeImportHeader(header))
                const hasSkuHeader = this.getImportColumnIndex(headerRow, 'sku') !== -1

                if (!hasSkuHeader) {
                    return lines.map((line) => {
                        const cells = this.splitPasteLine(line)
                        return { sku: String(cells[0] || '').trim() }
                    }).filter((row) => row.sku)
                }

                const columnIndexes = {
                    sku: this.getImportColumnIndex(headerRow, 'sku'),
                    qty: this.getImportColumnIndex(headerRow, 'qty'),
                    price: this.getImportColumnIndex(headerRow, 'price'),
                    'discount price': this.getImportColumnIndex(headerRow, 'discount price'),
                    'percent discount': this.getImportColumnIndex(headerRow, 'percent discount'),
                    total: this.getImportColumnIndex(headerRow, 'total'),
                    notes: this.getImportColumnIndex(headerRow, 'notes')
                }

                const rows = []
                lines.slice(1).forEach((line) => {
                    const cells = this.splitPasteLine(line)
                    const mapped = {
                        sku: this.getPasteCellValue(cells, columnIndexes.sku)
                    }

                    const qty = this.getPasteCellValue(cells, columnIndexes.qty)
                    const price = this.getPasteCellValue(cells, columnIndexes.price)
                    const discountPrice = this.getPasteCellValue(cells, columnIndexes['discount price'])
                    const percentDiscount = this.getPasteCellValue(cells, columnIndexes['percent discount'])
                    const total = this.getPasteCellValue(cells, columnIndexes.total)
                    const notes = this.getPasteCellValue(cells, columnIndexes.notes)

                    if (qty) {
                        mapped.qty = qty
                    }
                    if (price) {
                        mapped.price = price
                    }
                    if (discountPrice) {
                        mapped['discount price'] = discountPrice
                    }
                    if (percentDiscount) {
                        mapped['percent discount'] = percentDiscount
                    }
                    if (total) {
                        mapped.total = total
                    }
                    if (notes) {
                        mapped.notes = notes
                    }

                    if (mapped.sku) {
                        rows.push(mapped)
                    }
                })

                return rows
            },

            splitPasteLine(line) {
                if (line.includes('\t')) {
                    return line.split('\t')
                }

                return line.split(',')
            },

            getPasteCellValue(cells, columnIndex) {
                if (columnIndex === -1 || cells[columnIndex] === undefined || cells[columnIndex] === null) {
                    return ''
                }

                return String(cells[columnIndex]).trim()
            },

            async resolvePriceOverridePreference(importRows) {
                const hasPriceOverrides = importRows.some((row) => row.price !== undefined && String(row.price).trim() !== '')
                if (!hasPriceOverrides) {
                    return importRows
                }

                const result = await this.$swal({
                    icon: 'question',
                    title: 'Price column detected',
                    html: 'Use imported <strong>price</strong> values instead of SKU prices?',
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Use Imported Price',
                    denyButtonText: 'Use SKU Price',
                    cancelButtonText: 'Cancel'
                })

                if (result.isDismissed) {
                    return null
                }

                if (result.isConfirmed) {
                    return importRows
                }

                return importRows.map((row) => {
                    const normalizedRow = { ...row }
                    delete normalizedRow.price
                    return normalizedRow
                })
            },

            downloadImportSample() {
                const headers = ['SKU', 'QTY', 'Price', 'Discount Price', '% Discount', 'Notes']
                const worksheet = XLSX.utils.aoa_to_sheet([headers])
                const workbook = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Import Template')
                XLSX.writeFile(workbook, 'Generate_Picture_File_Import_Template.xlsx')
            },

            findDiscountConflict(importRows) {
                for (let index = 0; index < importRows.length; index++) {
                    const row = importRows[index]
                    const hasDiscountPrice = this.hasPopulatedImportValue(row['discount price'])
                    const hasPercentDiscount = this.hasPopulatedImportValue(row['percent discount'])

                    if (hasDiscountPrice && hasPercentDiscount) {
                        return `Row ${index + 2} has both Discount Price and % Discount. Only one may be used per row.`
                    }
                }

                return null
            },

            validateImportRows(importRows) {
                for (let index = 0; index < importRows.length; index++) {
                    const row = importRows[index]
                    const rowNumber = index + 2
                    const trimmedSku = String(row.sku || '').trim()

                    if (!this.isValidImportSku(trimmedSku)) {
                        return `Row ${rowNumber} has an invalid SKU. SKUs may only contain letters, numbers, periods, underscores, and hyphens with no spaces.`
                    }

                    const numericFields = [
                        ['price', 'Price'],
                        ['discount price', 'Discount Price'],
                        ['percent discount', '% Discount'],
                        ['total', 'Total']
                    ]

                    for (const [field, label] of numericFields) {
                        if (row[field] !== undefined && !this.isValidImportNumeric(row[field])) {
                            return `Row ${rowNumber} has a non-numeric ${label} value.`
                        }
                    }
                }

                return null
            },

            isValidImportSku(sku) {
                return /^[A-Za-z0-9._-]+$/.test(String(sku || '').trim())
            },

            isValidImportNumeric(value) {
                if (!this.hasPopulatedImportValue(value)) {
                    return true
                }

                return /^-?\d+(\.\d+)?$/.test(String(value).trim())
            },

            hasPopulatedImportValue(value) {
                return value !== undefined && value !== null && String(value).trim() !== ''
            },

            getImportColumnIndex(headerRow, columnKey) {
                const aliases = this.importColumnAliases[columnKey] || [columnKey]
                for (let index = 0; index < headerRow.length; index++) {
                    if (aliases.includes(headerRow[index])) {
                        return index
                    }
                }

                return -1
            },

            isExcelPercentFormattedCell(cell) {
                return !!(cell && cell.z && /%/.test(String(cell.z)))
            },

            getImportCell(worksheet, rowIndex, columnIndex) {
                if (columnIndex === -1) {
                    return null
                }

                return worksheet[XLSX.utils.encode_cell({ r: rowIndex, c: columnIndex })] || null
            },

            getImportCellValue(worksheet, rowIndex, columnIndex) {
                const cell = this.getImportCell(worksheet, rowIndex, columnIndex)
                if (!cell) {
                    return ''
                }

                if (cell.w !== undefined && cell.w !== null && String(cell.w).trim() !== '') {
                    return String(cell.w).trim()
                }

                if (cell.v !== undefined && cell.v !== null) {
                    return String(cell.v).trim()
                }

                return ''
            },

            async parseImportFile(file) {
                const arrayBuffer = await file.arrayBuffer()
                const workbook = XLSX.read(arrayBuffer, { type: 'array' })
                const firstSheetName = workbook.SheetNames[0]
                if (!firstSheetName) {
                    return []
                }

                const worksheet = workbook.Sheets[firstSheetName]
                const sheetRows = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' })
                if (!sheetRows.length) {
                    return []
                }

                const headerRow = sheetRows[0].map((header) => this.normalizeImportHeader(header))
                const columnIndexes = {
                    sku: this.getImportColumnIndex(headerRow, 'sku'),
                    qty: this.getImportColumnIndex(headerRow, 'qty'),
                    price: this.getImportColumnIndex(headerRow, 'price'),
                    'discount price': this.getImportColumnIndex(headerRow, 'discount price'),
                    'percent discount': this.getImportColumnIndex(headerRow, 'percent discount'),
                    total: this.getImportColumnIndex(headerRow, 'total'),
                    notes: this.getImportColumnIndex(headerRow, 'notes')
                }

                if (columnIndexes.sku === -1) {
                    throw new Error('Missing SKU column')
                }

                const rows = []
                sheetRows.slice(1).forEach((row, dataRowIndex) => {
                    const sheetRowIndex = dataRowIndex + 1
                    const rowNumber = sheetRowIndex + 1

                    if (columnIndexes['percent discount'] !== -1) {
                        const percentCell = this.getImportCell(worksheet, sheetRowIndex, columnIndexes['percent discount'])
                        if (percentCell && this.isExcelPercentFormattedCell(percentCell)) {
                            throw new Error(`Row ${rowNumber} uses Excel percentage formatting in % Discount. Enter a plain number only (e.g. 35).`)
                        }
                    }

                    const mapped = {
                        sku: this.getImportCellValue(worksheet, sheetRowIndex, columnIndexes.sku).trim()
                    }

                    const qty = this.getImportCellValue(worksheet, sheetRowIndex, columnIndexes.qty)
                    const price = this.getImportCellValue(worksheet, sheetRowIndex, columnIndexes.price)
                    const discountPrice = this.getImportCellValue(worksheet, sheetRowIndex, columnIndexes['discount price'])
                    const percentDiscount = this.getImportCellValue(worksheet, sheetRowIndex, columnIndexes['percent discount'])
                    const total = this.getImportCellValue(worksheet, sheetRowIndex, columnIndexes.total)
                    const notes = this.getImportCellValue(worksheet, sheetRowIndex, columnIndexes.notes)

                    if (qty) {
                        mapped.qty = qty
                    }
                    if (price) {
                        mapped.price = price
                    }
                    if (discountPrice) {
                        mapped['discount price'] = discountPrice
                    }
                    if (percentDiscount) {
                        mapped['percent discount'] = percentDiscount
                    }
                    if (total) {
                        mapped.total = total
                    }
                    if (notes) {
                        mapped.notes = notes
                    }

                    if (mapped.sku) {
                        rows.push(mapped)
                    }
                })

                return rows
            },

            normalizeImportHeader(header) {
                let normalized = String(header || '')
                    .toLowerCase()
                    .trim()
                    .replace(/[_-]/g, ' ')
                    .replace(/\s+/g, ' ')

                if (normalized === '% discount' || normalized === 'percent discount' || normalized === '%discount') {
                    return 'percent discount'
                }

                if (normalized === 'discountprice') {
                    return 'discount price'
                }

                if (normalized === 'quantity') {
                    return 'qty'
                }

                if (normalized === 'note') {
                    return 'notes'
                }

                return normalized
            },

            hasExistingImportData() {
                return this.row.items.some((item) => item && item.sku)
            },

            async resolveImportConflict(importedRows) {
                if (!this.hasExistingImportData()) {
                    return importedRows
                }

                const result = await this.$swal({
                    icon: 'question',
                    title: 'Existing rows found',
                    html: 'Would you like to replace existing rows or add/update by SKU?',
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Replace',
                    denyButtonText: 'Add/Update',
                    cancelButtonText: 'Cancel'
                })

                if (result.isDismissed) {
                    return null
                }

                if (result.isDenied) {
                    return this.mergeImportedRows(importedRows)
                }

                return importedRows
            },

            mergeImportedRows(importedRows) {
                const mergedRows = this.row.items.map((item) => ({ ...item }))
                const skuMap = {}

                mergedRows.forEach((row, idx) => {
                    if (row.sku) {
                        skuMap[String(row.sku).toLowerCase()] = idx
                    }
                })

                importedRows.forEach((importRow) => {
                    const normalizedSku = String(importRow.sku).toLowerCase()
                    if (Object.prototype.hasOwnProperty.call(skuMap, normalizedSku)) {
                        const targetIndex = skuMap[normalizedSku]
                        mergedRows[targetIndex] = {
                            ...mergedRows[targetIndex],
                            ...importRow
                        }
                    } else {
                        mergedRows.push(importRow)
                        skuMap[normalizedSku] = mergedRows.length - 1
                    }
                })

                return mergedRows
            },

            recalculateAllRows() {
                this.row.items.forEach((item, index) => {
                    this.calculateRow(index)
                })
            },

            deleteRow(index) {
                this.row.items.splice(index, 1)
            },

            scrollToElement(options, index) {
                this.$nextTick(() => {
                    const el = this.$el.getElementsByClassName('index-' + index)[0];

                    if (el) {
                        el.scrollIntoView(options);
                    }
                })
            },

            addTenRows() {
                for (var index = 0; index <= 10; index++) {
                    this.row.items.push(this.createEmptyRow())
                }
            },

            renderOptions(area) {
                if (area == 'from') {
                    if (this.row.to == this.row.from) {
                        this.locations.forEach((loc, idx, array) => {
                            if (loc != this.row.from) {
                                this.row.to = this.locations[idx]
                            }
                        })

                    }
                } else {
                    if (this.row.from == this.row.to) {
                        this.locations.forEach((loc, idx, array) => {
                            if (loc != this.row.to) {
                                this.row.from = this.locations[idx]
                            }
                        })

                    }
                }
            },

            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },

            fetchResults() {
                const query = this.row.items[this.currentIndex].sku

                clearTimeout(this.autosuggest.timeout)
                this.autosuggest.timeout = setTimeout(() => {
                    const productsPromise = axios.get('api/inventory/generatepicturefile/getproductsfilter/' + query)

                    Promise.all([productsPromise]).then(values => {
                        this.autosuggest.suggestions = []

                        // const products = this.filterResults(values[0].data, query, 'name')
                        const products = values[0].data.items

                        products.length &&
                        this.autosuggest.suggestions.push({ name: "products", data: products })
                    })
                }, this.autosuggest.debounceMilliseconds)
            },

            filterResults(data, text, field) {
                return data.items
                    .filter(item => {
                        if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
                            return item[field]
                        }
                    })
                    .sort()
            },

            calculateRow(index) {
                let qty = this.row.items[index].qty ? this.row.items[index].qty : 0
                let price = this.row.items[index].price ? this.row.items[index].price : 0
                let discountPrice = this.row.items[index].discountPrice ? this.row.items[index].discountPrice : 0
                let percentDiscount = this.row.items[index].percentDiscount ? this.row.items[index].percentDiscount : 0

                let totalBeforeDiscount = qty * price
                let total

                if (discountPrice) {
                    total = (discountPrice * qty).toFixed(2)
                } else if (percentDiscount) {
                    let discount = Math.round((price - (price * (percentDiscount * 0.01)) + Number.EPSILON) * 100) / 100
                    total = (qty * discount).toFixed(2)
                } else {
                    total = totalBeforeDiscount.toFixed(2)
                }

                this.row.items[index].total = total > 0 ? total : ''
            },

            clickHandler(item) {
                let query = this.row.items[this.currentIndex].sku;
                if (!query) {
                    this.autosuggest.suggestions = []
                    this.clearProductFields(this.currentIndex)
                }
            },

            onSelected(item) {
                if (item) {
                    this.applyProductToRow(this.currentIndex, item.item)
                }
            },

            onInputChange(text) {
                // console.log(text)
              // event fired when the input changes
              // console.log(text)
            },

            onItemChanged(text) {
                // this.row.items[this.currentIndex].sku = text.item.name
            },

            onKeyTab(evt) {
                // evt.preventDefault()
                let query = this.row.items[this.currentIndex].sku.toUpperCase()

                setTimeout(() => {
                    if (this.autosuggest.suggestions.length) {
                        let results = this.autosuggest.suggestions[0].data

                        let resultName = results[0].name

                        if (resultName == query) {
                            this.applyProductToRow(this.currentIndex, results[0])
                            this.autosuggest.suggestions = []
                        } else {
                            this.autosuggest.suggestions = []
                        }
                    }
                }, 1500)
            },

            getSuggestionValue(suggestion) {
                return suggestion.item.name
            },

            focusMe(index) {
                this.currentIndex = index

                if (this.row.items.length == index + 1) {
                    this.row.items.push(this.createEmptyRow())

                    this.scrollToElement({behavior: 'smooth'}, index + 1)
                }

            },

            suggestFirst(index, query) {
                let hasQuery = this.row.items[index].sku

                if (hasQuery) {
                    let suggests = this.autosuggest.suggestions
                    if (typeof suggests[0] !== 'undefined') {
                        let arr = suggests[0].data

                        if (arr.length) {
                            for (var i = 0; i < arr.length; i++) {
                                let cur = arr[i].name.toLowerCase()
                                if (cur.includes(query.toLowerCase())) {
                                    this.applyProductToRow(index, arr[i])
                                    this.autosuggest.suggestions = []

                                    break;
                                } else {
                                    continue
                                }
                            }
                        }
                    } else {
                        let target = 'input' + (index + 1)
                        this.$refs[target][0].$el.childNodes[0].childNodes[0].focus()
                    }
                } else {
                    let target = 'input' + (index + 1)
                    this.$refs[target][0].$el.childNodes[0].childNodes[0].focus()
                }
            },

            filteredOptions(index) {
                return [
                    {
                        data: this.products[0].data.filter(option => {
                            return option.name.toLowerCase().indexOf(this.row.items[index].sku.toLowerCase()) > -1
                        })
                    }
                ]
            },

            forceFileDownload(response, ext){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Generated_Picture_File_' + +new Date() + '.' + ext) //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Picture file generated successfully!')
            },

            exportExcel() {
                let url = 'api/inventory/generatepicturefile/exportexcel'
                axios.post(url, {
                    rows: this.row.items,
                    show: {
                        ...this.show,
                        wac: this.canViewWac && this.show.wac
                    },
                    headerText: this.headerText
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res, 'xlsx')
                }, () => {
                    this.has_error = true
                })
            },

            exportPDF() {
                let url = 'api/inventory/generatepicturefile/exportpdf'
                axios.post(url, {
                    rows: this.row.items,
                    show: this.show,
                    headerText: this.headerText
                },
                {
                    responseType: 'blob',
                })
                .then((res) => {
                    this.forceFileDownload(res, 'pdf')
                }, () => {
                    this.has_error = true
                })
            },

            resetView() {
                this.row.items = []
                this.headerText = ''
                this.show = {
                    title: true,
                    price: true,
                    instock: false,
                    wac: false,
                    qoo: false,
                    qop: false,
                    category: false
                }

                for (var index = 0; index <= 25; index++) {
                    this.row.items.push(this.createEmptyRow())
                }

                this.currentIndex = ''
            }
		},

        computed: {
            canViewWac() {
                return this.$can('view-all') || this.$can('view-product-cost')
            }
        },

        mounted() {
            this.resetView()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-generatepicturefile-excel-paste':
                        this.modals[modalId].active = 0
                        break
                }
            })
        }
	}
</script>

<style lang="scss">
    #generate-picture-file {
        .button-row {
            margin-bottom: 5px;

            .import-file-wrap {
                min-width: 0;
            }

            .sample-link {
                font-size: 0.85rem;
            }

            .fa-file-excel {
                color: green;
            }

            .fa-file-pdf {
                color: red;
            }
        }

        table {
            td {
                vertical-align: middle;
            }

            input {
                width: 100%;
            }

            .qty {
                width: 60px;
            }

            .price {
                width: 110px;
            }

            .hide-data {
                text-decoration: line-through;
            }

            .products-thumbs {
                width: 50px;
                max-height: 50px;
            }
        }

        .options-assign {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

            input {
                width: 100%;
                padding: 0.5rem;
                height: calc(1.5em + 0.3rem + 2px);
            }

            ul {
                width: 100%;
                color: rgba(30, 39, 46,1.0);
                list-style: none;
                margin: 0;
                padding: 0.5rem 0 .5rem 0;
            }

            li {
                margin: 0 0 0 0;
                border-radius: 5px;
                padding: 0.75rem 0 0.75rem 0.75rem;
                display: flex;
                align-items: center;
            }

            li:hover {
                cursor: pointer;
            }

            .autosuggest-container {
                display: flex;
                // justify-content: center;
                width: 100%;

                li {
                    white-space: nowrap;
                    text-align: left;
                }
            }

            #autosuggest { width: 100%; display: block; }

            .autosuggest__results {
                position: relative;
            }

            .autosuggest__results-container {
                width: 300px;
            }

            .autosuggest__results-item--highlighted {
                background-color: rgba(51, 217, 178,0.2);
            }

            #autosuggest-autosuggest__results {
                overflow-y: hidden;
                // max-height: 200px;
            }
        }
    }
</style>
